<template>
  <div class="supports">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="supports_header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="form-group--wrap">
        <div class="form_select">
          <tree-select
              :options="executor_list"
              v-model="filter.executor_user_id"
              :placeholder="translate('support.executor')"
              :clearable="true"
              @input="change_input"
          />

          <tree-select
              :options="client_list"
              v-model="filter.client_id"
              :placeholder="translate('support.client')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <fg-input
              type="text"
              v-model="filter.search"
              :placeholder="translate('support.search')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="status_list"
              v-model="filter.status"
              :placeholder="translate('support.status')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="topic_list"
              v-model="filter.topic_id"
              :placeholder="translate('support.subject')"
              :clearable="true"
              @input="change_input"
          />
        </div>
        <div class="form_select"></div>

        <div class="form_select">
          <span
              class="btn btn-warning btn-fill"
              @click.prevent="clear_filter()"
          >
            {{ translate('filter.reset') }}
          </span>

          <span
              class="btn btn-info btn-fill"
              @click.prevent="get_my_tickets()"
          >
            <b>{{ translate('support.my_tickets') }}</b>
          </span>

          <span
              class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
              @click.prevent="new_ticket({})"
          >
            <b>{{ translate('support.add') }}</b>
          </span>
        </div>
      </div>
    </div>

    <div class="supports_table">
      <div class="loading" v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>
      <TicketTable
          v-else
          :filter_asc="filter_asc"
          :filter_type="filter_type"
          :tickets="tickets"
          @check_link="checker"
          @change_filter="change_filter"
          @update_ticket_list="get_ticket_list"
      />
    </div>
  </div>
</template>

<script>
import TicketTable from './TicketTable/TicketTable.vue'
import NewTicket from "./Modal/NewTicket.vue";
export default {
  name: 'Supports',
  components: {
    TicketTable
  },

  data () {
    return {
      filter_type: 'status',
      filter_asc: 'asc',
      check_link: true,
      filter: {
        search: "",
        status: null,
        client: null,
        topic: null,
        executor_user_id: null
      },
      ticket_list: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      loading: false
    }
  },

  created () {
    this.get_ticket_list()
  },

  computed: {
    user(){
      return this.$store.getters.getUser
    },
    tickets () {
      let list = [...this.ticket_list]
      if (list.length > 0) {
        list.sort(this.compareNumbers)
      }
      return list
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
    status_list () {
      let status_list = this.$store.getters.getSupportInfo.statuses
      return Object.keys(status_list).map((key) => {
        return { id: key, label: status_list[key].title }
      })
    },

    topic_list(){
      return this.$store.getters.getSupportInfo.topics.map((topic) => {
        return {id: topic.id, label: topic.name}
      })
    },

    executor_list(){
      return this.$store.getters.getCompanyUserList.map((user) => {
        return {id: user.id, label: user.name}
      })
    }
  },

  methods: {
    clear_filter(){
      this.filter = {
        search: "",
        status: null,
        client: null,
        topic: null,
        executor_user_id: null
      }
    },
    get_my_tickets(){
      this.filter.executor_user_id = this.user.id
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_ticket_list, 200)
    },
    new_ticket (val) {
      let t = this.$createElement(NewTicket, {props: {ticket: val}, on: {
          close: () => {
            this.$modal.hide('new_ticket')
          },
          update: () => {
            this.$modal.hide('new_ticket')
            this.get_ticket_list()
          },
        }})
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'new_ticket'})
    },

    get_ticket_list(){
      let filter = {...this.filter}
      Object.keys(filter).forEach((key) => {
        if (!filter[key]) delete filter[key]
      })
      this.loading = true
      this.$http.v1.getTicketList(filter, (response) =>{
        this.ticket_list = response.data
        this.loading = false
      })
    },
    checker(){
      this.check_link = false
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
  .supports{
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    padding-top: 20px;

    .main_filters{
      top: 20px;
    }

    &_header{
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      flex: 1;
      .form_select{
        flex: 1;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        .vue-treeselect{
          margin-bottom: 0;
          height: 40px;
        }
        .btn{
          padding: 0;
          height: auto;
        }
      }
      .form-group{
        margin-bottom: 0;
        width: 100%;
        position: relative;
        .form-control{
          border-radius: 4px 0 0 4px;
          border: 1px solid #ccc;
        }
        &--wrap{
          flex: 1;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;

          span{
            height: 40px;
            font-size: 14px;
            padding: 7px 10px;
          }
        }
        .mdi-close{
          position: absolute;
          right: 0;
          top: calc(50% - 7px);
          color: darksalmon;
          cursor: pointer;
        }
      }
      .btn-fill{
        height: 40px;
      }
    }

    &_table{
      flex: 10;
      margin-top: 10px;
      overflow: auto;
    }
  }

  @media (max-width: 500px){
    .supports{
      padding: 0 5px;
    }
  }
</style>
